import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_REPORTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { ReportFilters } from './types'

type SalaryDeductionDeviceReportOriginal = {
  name: string
  employee_no: string
  phone_no: string
  co_accounting_code: string | null
  accounting_code: string
  department_code: string
  department_name: string
  model: string
  delivery_date: string | null
  net_vat: number | null
  cover_amount: number
  dim1: null | string
  fixed_salary_deduction_amount: number
  content_service_amount: number
  remainder_amount: number
  total_amount: number
  amount: number
  customer_id: number
  customer_name: string
  customer_head_id: number
  project_device: string
  order_date: string
  order_update: string
  down_payments: number
  department_override_device: string | null
  is_buyout: boolean
  org_no: string
}

const IS_NEW_BACKEND_API = true

export const getSalaryDeductionDeviceReports = async ({
  selectedReportType,
  toDate,
  fromDate,
  isGlobal,
  selectedCustomer,
}: ReportFilters) => {
  if (!fromDate || !toDate) throw Error('Missing date range filters!')

  const searchParams = new URLSearchParams()
  searchParams.append('fromDate', fromDate)
  searchParams.append('toDate', toDate)
  searchParams.append('isGlobal', isGlobal.toString())
  searchParams.append('customerId', String(selectedCustomer || ''))

  const reports = await get<SalaryDeductionDeviceReportOriginal[]>(
    `${API_ROUTE_ADMIN_REPORTS}/${selectedReportType}?${searchParams.toString()}`,
    IS_NEW_BACKEND_API
  )
  return mapKeysToCamelCase(reports)
}
